<div class="container">
  <app-shared-action-bar [saveReady]="unsavedChanges" [undoReady]="unsavedChanges"
    [displayActionSectionBar]="showActionSectionBar" (saveRequest)="saveGroup()"
  (undoRequest)="resetGroup()"></app-shared-action-bar>
  <div class="mt-20 px-4 md:px-8 ">

    <div class="my-4">
      <h2 class="settings-header">Group Assignment</h2>
    </div>

    @if (!noGroups) {
      <div>
        @if (!groupSelected) {
          <div class="mt-5" >
            <select class="mt-2 mr-4 text-box xl:w-2/5" [(ngModel)]="selectedGroup">
              @for (g of groups.Groups; track g) {
                <option [disabled]="g.UserID == -1" [ngValue]="g">{{g.DisplayName}}
                </option>
              }
            </select>
            <button class="btn-primary mt-3" (click)="loadGroup()" [disabled]="selectedGroup.UserID==-1">Select
            </button>
          </div>
        }
        @if (groupSelected) {
          <div class="flex-col mt-8">
            <div class="mt-4 flex items-center" >
              <p class="settings-selected-item mr-2">{{loadedGroup.DisplayName}} </p><span (click)="showDDL()"
              class="hover:cursor-pointer text-xl material-symbols-outlined">
              edit
            </span>
          </div>
          <div class="mt-2 border-solid ">
            <table class="xl:w-1/5 lg:w-2/5 my-4 w-full">
              <thead>
                <tr class="pb-3">
                  <th class="text-left">Name</th>
                  <th class="text-center">Group Member</th>
                </tr>
              </thead>
              <tbody>
                @for (u of completeUserList; track u) {
                  <tr>
                    <td>
                      {{u.DisplayName}}
                    </td>
                    <td class="flex justify-center py-2">
                      <app-toggle-switch [(checked)]="u.Selected" (checkedChange)="checkForChanges()"></app-toggle-switch>
                    </td>
                  </tr>
                }
              </tbody>
            </table>

        </div>
      </div>
    }
  </div>
}
@if (noGroups) {
  <div class="mx-6 mt-4">
    <p class="text-danger-base text-xl">No Group Editing Permissions</p>
  </div>
}
</div>
</div>
